import React, { Component } from "react";
import "./App.css";
import EDDLicenseActivator from "./components/EDDLicenseActivator";
import WebViewerApi from "./components/WebViewerApi";
import Zwibbler from "./components/Zwibbler";

import ReactGA from "react-ga";
ReactGA.initialize("UA-15480392-4");

class App extends Component {
  render() {
    return (
      <WebViewerApi>
        <EDDLicenseActivator eddItemId={328589} LicensedApp={Zwibbler} />
      </WebViewerApi>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js